import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { HttpClient } from '@angular/common/http';
import { ApprovalsResponse } from '../models/tank-approvals-response.interface';
import { Observable } from 'rxjs';
import { GasMeterDetails } from '../models/gas-meter-catalog.interface';

@Injectable({
  providedIn: 'root'
})
export class GasMeterApprovalsService extends CommonService {
  token = '';

  constructor(private httpCli: HttpClient) {
    super(httpCli);
    this.token = sessionStorage.getItem('token')!;
  }

  getApprovals(meterId: number) {
    const options = this.getHeaders(this.token);
    return this.http.get<ApprovalsResponse[]>(`${this.apiURL}/gas_meters/${meterId}/gas_meter_approvals`, options);
  }

  validateSerialNumber(serial: string): Observable<GasMeterDetails> {
    const options = this.getHeaders(this.token);
    return this.http.get<GasMeterDetails>(`${this.apiURL}/gas_meters/serial/${serial}`, options);
  }

  validateQrCode(code: string): Observable<GasMeterDetails> {
    const options = this.getHeaders(this.token);
    return this.http.get<GasMeterDetails>(`${this.apiURL}/gas_meters/code/${code}`, options);
  }
}
